import apiService from '@/services/apiService';

const actions = {
  getPaxelBigCustomers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/customer/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaxelBigCustomerAll({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/customer/find-all', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaxelBigCustomerStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/customer/all-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaxelBigCustomer({ commit }, payload) {
    apiService.get(`paxel-big/customer/${payload}`)
      .then((response) => {
        commit('getPaxelBigCustomer', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateStatusPaxelBigCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-big/customer/${payload.id}/update-status`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderPaxelBigCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-big/customer/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPaxelBigCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/customer', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPaxelBigCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-big/customer/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delPaxelBigCustomer({ commit }, payload) {
    apiService.delete(`paxel-big/customer/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
